<template>
  <div
    class="cont-biaoqian have-tit"
    v-if="queryParam.userId == queryParam.currentUserId"
  >
    <div class="user-much-num">我的标签</div>
    <div class="cons-ipt">
      <el-input
        class="ipt"
        v-model="tagIpt"
        placeholder="个人标签，不超过7个汉字/14个英文字符"
      ></el-input>
      <el-button class="btn" @click="addImpress()">添加标签</el-button>
    </div>
    <div class="bott-tit">下面哪些标签比较与您符合</div>
    <div class="tags">
      <template v-for="(item, index) in tableData">
        <template v-if="item.mySelected == 1">
          <span :key="index" @click="accept(item)" class="tag active"
            >{{ item.impressName }}
            <i class="much">{{ item.attentionCount }} </i></span
          >
        </template>
        <template v-else>
          <span :key="index" class="tag " @click="accept(item)"
            >{{ item.impressName
            }}<i class="much">{{ item.attentionCount }} </i></span
          >
        </template>
      </template>
    </div>
  </div>

  <div class="cont-biaoqian have-tit" v-else>
    <div class="user-much-num">他的标签</div>
    <div class="bott-tit">告诉好友你对他的印象</div>
    <div class="tags renke">
      <template v-for="(item, index) in tableData">
        <template v-if="item.otherSelected == 1">
          <span :key="index" @click="accept(item)" class="tag active"
            >{{ item.impressName }}<i class="much">{{ item.attentionCount }}</i
            ><i class="rk">认可</i></span
          >
        </template>
        <template v-else>
          <span :key="index" class="tag" @click="accept(item)"
            >{{ item.impressName }}<i class="much">{{ item.attentionCount }}</i
            ><i class="rk">认可</i></span
          >
        </template>
      </template>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import axios from 'axios';
import vue from 'vue';

vue.prototype.$axios = axios;

import { mapState } from "vuex";
import updateTdk from "@/utils/tdk";

export default {
    components: {},
    data() {
        return {
          headTitle: "title---rrdh",
          headKeywords: "keywords---rrdh",
          headDesc: "description---rrdh",
          isMounted: false, //for control not ssr render

          tableData: [],
            tagIpt: '',
            fullscreenLoading: true,
            queryParam: {
                userId: 0,
                currentUserId: 0
            },
            callbackurl: "",
        }
    },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com/biaoqian">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
    mounted() {

      this.isMounted = true;

      let _this = this
      let id = _this.$route.query.userId
      if (id && parseInt(id) !== 0) {
        _this.queryParam.userId = id
      }
      if (_this.global.userModel != null) {
        _this.queryParam.currentUserId = _this.global.userModel.id
      }

      this.callbackurl = "login?callback=" + window.location.href;


      const alreadyIncremented = !!this.productionDetail;
      if (!alreadyIncremented) {
        this.fetchData().then(this.initData());
      } else {
        this.initData();
      }


        // _this.getUserImpress(_this.queryParam.userId, _this.queryParam.currentUserId)
        // _this.setTitle(_this.queryParam.userId)
    },
    methods: {
      fetchData(){
        return this.$store
                .dispatch("FETCH_USER_DETAIL", {
                  id: this.$route.query.userId
                })
                .finally(() => {
                  this.$loading(false);
                  this.setSeo()
                  updateTdk.call(this);
                });
      },
      initData(){
        console.log("biaoqian===this.queryParam.userId=====>",this.queryParam.userId)
        console.log("biaoqian===this.queryParam.currentUserId=====>",this.queryParam.currentUserId)
        this.getUserImpress(this.queryParam.userId, this.queryParam.currentUserId);
      },
      setSeo(){
        this.headTitle = this.userDetail.userName+"的个人标签——人人动画网【官网】";
        this.headKeywords = this.userDetail.impressStr;
        this.headDesc =this.userDetail.userName+"的个人标签";
      },
        // setTitle(userId){
        //     let _this = this
        //     let head = document.getElementsByTagName('head');
        //     let meta = document.createElement('meta');
        //     let userUrl = "/rrbi/userInfo/userInfo/" + userId;
        //     _this.$axios.get(userUrl).then(function(result){
        //         if (result.data.code) {
        //             document.title =result.data.response.userName+"的标签——人人动画网【官网】"
        //             document.querySelector('meta[name="description"]').setAttribute('content', result.data.response.userName+"的标签")
        //         }
        //     })
        // },
        getUserImpress(userId, currentUserId) {
            let _this = this;
            _this.fullscreenLoading = true
            let url = '/rrbi/impress/user?userId=' + userId + '&currentUserId=' + currentUserId + '&type=0' + '&time=' + new Date().getMilliseconds();
            this.$axios.get(url).then(function (result) {
                console.log(result.data.response)
                if (result.data.code == 1) {
                    _this.tableData = result.data.response
                }
                _this.fullscreenLoading = false
            })
        },
        accept(item) {
            let _this = this;
            let loginurl = '/api/checkLogin?time=' + new Date().getMilliseconds();
            this.$axios.get(loginurl).then(function (result) {
                if (result.data.isLogin && result.data.casFastUserModel != null) {
                    let url = '/rrbi/impress/accept/' + item.id + '?currentUserId=' + _this.queryParam.currentUserId + "&userId=" + _this.queryParam.userId +'&time=' + new Date().getMilliseconds()
                    _this.$axios.get(url).then(function (result) {
                        console.log(result.data.response)
                        _this.getUserImpress(_this.queryParam.userId, _this.queryParam.currentUserId)
                    })
                } else {
                    window.location.href = "http://www.renrendonghua.com/" + _this.callbackurl;

                }
            })

        },
        addImpress() {
            let _this = this
            if (_this.tagIpt == '') {
                _this.$message.error("请输入标签内容")
                return
            }
            if (_this.strlen(_this.tagIpt) > 14) {
                _this.$message.error("个人标签，不超过7个汉字/14个英文字符")
                return
            }
            let loginurl = '/api/checkLogin?time=' + new Date().getMilliseconds();
            this.$axios.get(loginurl).then(function (result) {
                if (result.data.isLogin && result.data.casFastUserModel != null) {

                    let url = '/rrbi/impress/add?userId=' + _this.queryParam.userId + '&creatorId=' + _this.queryParam.currentUserId + '&type=0' + '&impressName=' + _this.tagIpt + '&time=' + new Date().getMilliseconds();
                    _this.$axios.post(url).then(function (result) {
                        console.log(result.data.response)
                        if (result.data.code == 1) {
                            _this.$message.success("添加成功")
                            _this.tagIpt = ''
                        } else {
                            _this.$message.error(result.data.message)
                        }
                        _this.getUserImpress(_this.queryParam.userId, _this.queryParam.currentUserId)
                    })
                } else {
                    window.location.href = "http://www.renrendonghua.com/" + _this.callbackurl;

                }
            })


        },
        strlen(str) {
            var len = 0;
            for (var i = 0; i < str.length; i++) {
                var c = str.charCodeAt(i);
                //单字节加1
                if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                    len++;
                } else {
                    len += 2;
                }
            }
            return len;
        }
    }

}
</script>

<style scoped lang="less">
.cont-biaoqian {
  background: #fff;

  .cons-ipt {
    padding: 50px;
    border-bottom: 1px solid #f6f6f6;

    .ipt {
      margin-right: 20px;
      width: 360px;
    }
  }

  .bott-tit {
    padding-top: 20px;
    color: #808080;
    font-size: 18px;
    text-align: center;
  }

  .tags {
    padding: 20px 50px 50px;
    font-size: 0;

    .tag {
      position: relative;
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 5px 20px;
      font-size: 16px;
      line-height: 22px;
      background: #f6f6f6;
      cursor: pointer;
      border-radius: 4px;

      &.active {
        color: #fff;
        background: @HEADBG;
      }
      .much {
        margin-left: 5px;
        font-style: normal;
      }
    }

    &.renke {
      .tag {
        margin-right: 65px;

        .much {
          margin-left: 5px;
          font-style: normal;
        }

        .rk {
          position: absolute;
          left: 100%;
          top: 0;
          padding-left: 8px;
          width: 55px;
          height: 100%;
          line-height: 32px;
          font-size: 12px;
          font-style: normal;
          background: url("../../../assets/images/icon_renke.png");
          background-position: 36px 10px;
          background-repeat: no-repeat;
        }

        &.active {
          color: #fff;
          background: @HEADBG;

          .rk {
            color: @HEADBG;
            background-image: url("../../../assets/images/icon_renke_active.png");
          }
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .cont-biaoqian {
    .cons-ipt {
      padding: 20px 10px;
      display: flex;

      .ipt {
        flex: 1;
      }

      .btn {
        flex: 0 0 90px;
        width: 90px;
      }
    }

    .tags {
      padding: 20px 10px;

      .tag {
        font-size: 14px;
      }
    }
  }
}
</style>
